import Button from "components/atoms/Button";
import BuyNowButton from "components/atoms/BuyNowButton";
import Icon from "components/atoms/Icon";
import Image from "components/atoms/Image";
import Link from "components/atoms/Link";
import Loading from "components/atoms/Loading";
import LoadingState from "components/atoms/LoadingState";
import Tag from "components/atoms/Tag";
import Text from "components/atoms/Text";
import Rcrating from "components/molecules/rcrating";
import { setLastAddtocartProductItem } from "constants/addtocart";
import colors, { lava } from "constants/colors";
import { BASE_URL } from "constants/env";
import { COMMON_LOADING_SIZE } from "constants/loading";
import { getDefaultLocationDeliveryStore } from "constants/location";
import {
  RatingContainer,
  RatingReviewCounting,
  WrapLoading,
} from "constants/styledComponent";
import { useSelector } from "hooks/useApp";
import useCompare from "hooks/useCompare";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { descreaseIncreaseCartProducts } from "redux/actions/products/cart";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import { trackingAddToCartEvent } from 'utils/trackingGA';
import "./index.scss";

interface ProductitemProps {
  element?: string;
  modifiers?: Modifiers;
  name?: string;
  sku?: string;
  price?: string;
  oldPrice?: string;
  addToCardButton?: boolean;
  compareButton?: boolean;
  product?: APIProduct;
  className?: string;
  trademarks?: string[];
  hasCashbackLabel?: boolean;
  tags?: string[];
  list?: "relatived-products";
  onToggleInfoBuyingForm?: (id: number) => void;
  onBuyingNow?: () => void;
  onCompare?: (
    e: any,
    product_id: number,
    product_type_id: number,
    product_parent_type_id: number,
  ) => void;
  slug?: string;
}

const Product: React.FC<ProductitemProps> = ({
  element,
  modifiers,
  addToCardButton,
  product,
  onCompare,
  trademarks,
  hasCashbackLabel,
  className,
  onToggleInfoBuyingForm,
  tags,
  onBuyingNow,
  list,
  slug
}: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    compare: { data: compareList },
  } = useSelector(state => state.pages);
  const { handleCompare, handleUnCompare } = useCompare(compareList);
  const { locationBuying } = useSelector(state => state);
  const { loading: loadingToAddToCart } = useSelector(
    state => state.products.cart,
  );
  const [isBuyingClicked, setIsBuyingClick] = useState(false);

  const isBuyItem = useMemo(
    () =>
      (product && product.product_type_id === 1) ||
      product.product_type_id === 2 ||
      product.product_type_id === 3 ||
      product?.is_buy, // sản phẩm của danh mục combo
    [product],
  );

  const addToCard = (e: any, productData: APIProduct) => {
    e.preventDefault();
    if (isBuyItem) {
      dispatch(descreaseIncreaseCartProducts(productData, "+"));

      // ga tracking
      // if (
      //   ReactGA.plugin &&
      //   ReactGA.plugin.execute &&
      //   typeof ReactGA.plugin.execute === "function"
      // ) {
      //   // ReactGA.plugin.execute("ecommerce", "addItem", {
      //   //   id: productData.product_id, // Transaction ID. Required.
      //   //   name: productData.name, // Product name. Required.
      //   //   sku: productData.model, // SKU/code.
      //   //   price: Number(productData.price), // Unit price.
      //   //   category: productData.product_type_id, // Category or variation.
      //   //   quantity: 1, // Quantity.
      //   // });
      //   // ReactGA.plugin.execute("ecommerce", "send", null);
      //   // ReactGA.plugin.execute("ecommerce", "clear", null);

      //   // ec:addtocart
      //   ReactGA.plugin.execute("ec", "addProduct", {
      //     id: productData.model, // Transaction ID. Required.
      //     name: productData.name, // Product name. Required.
      //     sku: productData.model, // SKU/code.
      //     price: Number(productData.price), // Unit price.
      //     revenue: Number(productData.price), // Unit price.
      //     ...(product.name_product_type
      //       ? { category: product.name_product_type }
      //       : {}), // Category or variation.
      //     quantity: 1, // Quantity.
      //     list: "Detail To Cart", // List name.
      //   });
      //   ReactGA.plugin.execute("ec", "setAction", "add");
      // }

      const discount = ((Math.round(productData.price / 1000) * 1000) * (productData.discount?.discount_value?.split(".")[0] || 0)) / 100;

      trackingAddToCartEvent({
        currency: 'VND',
        value: Math.round(productData.price / 1000) * 1000,
        items: [
          {
            item_id: productData.model,
            item_name: productData.name,
            discount,
            affiliation: "Daikin-E",
            price: Math.round(productData.price / 1000) * 1000,
            quantity: 1,
            item_category: productData?.name_product_type || '',
          }
        ]
      });

      // fbPixelId tracking
      if (ReactPixel.fbq && typeof ReactPixel.fbq === "function") {
        ReactPixel.fbq("track", "AddToCart", {
          id: productData.model, // Transaction ID. Required.
          name: productData.name, // Product name. Required.
          sku: productData.model, // SKU/code.
          price: Number(productData.price), // Unit price.
          category: productData.product_type_id, // Category or variation.
          quantity: 1, // Quantity.
          content_type: 'product', // required property
          content_ids: productData.model // required property
        });
      }

      setIsBuyingClick(true);
      setLastAddtocartProductItem(product.id);
    } else {
      onToggleInfoBuyingForm(productData.id);
    }
  };

  const [compareSelected, setCompareSelected] = useState(false);

  useEffect(() => {
    try {
      setCompareSelected(
        compareList.find(c => c.id === product.id) ? true : false,
      );
    } catch { }
  }, [compareList, product]);

  useEffect(() => {
    if (!loadingToAddToCart && isBuyingClicked) {
      setIsBuyingClick(false);
      history.push("/gio-hang");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingToAddToCart, isBuyingClicked]);

  const [onProcessLocation, setOnProcessLocation] = useState(false);

  const [outOfStock, setOutOfStock] = useState<1 | 2 | 0>();
  // 1 het hang
  // 2 het hang / tinh thanh dang chon
  // 0 con hang

  useEffect(() => {
    if (product) {
      setOnProcessLocation(true);
      const availableList =
        !!product.productCity &&
        typeof product.productCity === "object" &&
        typeof product.productCity.map === "function";

      // has productCity to continue:
      const dfLocation = getDefaultLocationDeliveryStore();
      const isDfLocationAvailable =
        availableList &&
        !![...product.productCity].find(
          item =>
            dfLocation && item.cityId === dfLocation.id && item.status === 1,
        ); //tim thay dfLocation trong productCity & con hang

      // has productCity to continue:
      if (
        product.out_stock === 1 ||
        (availableList &&
          ![...product.productCity].some(item => item.status === 1))
      ) {
        setOutOfStock(1); // het hang
      } else if (!isDfLocationAvailable) {
        setOutOfStock(2); // 2 het hang / tinh thanh dang chon
      } else {
        setOutOfStock(0); // 0 con hang
      }
    }
    setOnProcessLocation(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, locationBuying]);

  const redirectProductDetailFromRating = useCallback(
    (slug: string) => {
      history.push(`/san-pham/${slug}`, {
        actionTarget: "rating",
      });
    },
    [history],
  );

  // ec:addProduct click
  const handleAddDetailView = (product: any) => {
    ReactGA.plugin.execute("ec", "addProduct", {
      id: product.model, // Transaction ID. Required.
      name: product.name, // Product name. Required.
      sku: product.model, // SKU/code.
      price: Number(product.price), // Unit price.
      revenue: Number(product.price), // Unit price.
      ...(product.name_product_type
        ? { category: product.name_product_type }
        : {}), // Category or variation.
      list: "Detail View", // List name.
    });
    ReactGA.plugin.execute("ec", "setAction", "click");
  };

  // ec:addImpression
  const handleAddImpression = (product: any) => {
    ReactGA.plugin.execute("ec", "addImpression", {
      id: product.model, // Transaction ID. Required.
      name: product.name, // Product name. Required.
      sku: product.model, // SKU/code.
      price: Number(product.price), // Unit price.
      revenue: Number(product.price), // Unit price.
      ...(product.name_product_type
        ? { category: product.name_product_type }
        : {}), // Category or variation.
      ...(product.name_product_type ? { list: product.name_product_type } : {}), // List name.
    });
    ReactGA.plugin.execute("ec", "setAction", "detail");
  };

  const discountType = useMemo(
    () => product && product.discount?.discount_type,
    [product],
  );
  const discountValue = useMemo(
    () => product && product.discount?.discount_value,
    [product],
  );
  const formattedPrice = useMemo(
    () =>
      product &&
      window.formatMoney(
        discountType === 1
          ? Math.round((product.price * (1 - discountValue / 100)) / 1000) *
          1000
          : Math.round((product.price - discountValue) / 1000) * 1000,
      ),
    [discountType, discountValue, product],
  );
  const formattedPricePromotion = useMemo(
    () => {
      if (!discountValue) return "";
      if (discountType === 1) {
        return discountValue.split(".")[0];
      }
      return Math.round(discountValue / product.price * 100);
    },
    [discountType, discountValue, product.price],
  );

  const roundedPrice = useMemo(
    () =>
      product && window.formatMoney(Math.round(product.price / 1000) * 1000),
    [product],
  );
  const productTypeIdValue = useMemo(
    () =>
      (product && product.product_type_id === 3) || //hai dan roi
      product.product_type_id === 4 || //sky-air
      product.product_type_id === 5 || //sky-air
      product.product_type_id === 6 || //sky-air
      product.product_type_id === 7 || //sky-air
      product.product_type_id === 8 || //sky-air
      product.product_parent_type_id === 4,
    [product],
  );

  return product ? (
    <>
      <div className="m-product_link">
        <div
          className={joinClassnames(
            mapMultiClassnames("m-product", modifiers, element),
            className,
          )}
        >
          {/* hinh */}
          <div className="m-product_image-and-info">
            <div className="m-product_image">
              <div className="m-product_image_bg">
                <Link
                  href={`/san-pham/${product.slug}`}
                  onClick={() => {
                    list && list === "relatived-products"
                      ? handleAddImpression(product)
                      : handleAddDetailView(product);
                  }}
                >
                  <Image
                    src={
                      product &&
                      product.thumbnail &&
                      `${BASE_URL}${product.thumbnail}`
                    }
                    alt={`Image Product ${product.name}`}
                  />
                </Link>
              </div>
            </div>
            {/* info */}
            <div className="m-product_info">
              {/* {hasCashbackLabel ? (
                <div className="cashback-label-container">
                  {product.cashback_text && (
                    <CashBackLabel>{product.cashback_text}</CashBackLabel>
                  )}
                </div>
              ) : null} */}
              {hasCashbackLabel ? (
                <div className="cashback-label-container">
                  {product.image_tag && (
                    <Image
                      src={`${BASE_URL}/${product.image_tag}`}
                      alt={product.image_tag}
                    />
                  )}
                </div>
              ) : null}
              <div className="m-product_name">
                <Link
                  href={`/san-pham/${product.slug}`}
                  onClick={() => {
                    list && list === "relatived-products"
                      ? handleAddImpression(product)
                      : handleAddDetailView(product);
                    history.push(`/san-pham/${product.slug}`);
                  }}
                >
                  {product.name}
                </Link>
              </div>
              <div className="m-product_model">Model: {product.model}</div>
              {isBuyItem && (
                <div className="m-product_price">
                  {product.discount &&
                    Object.keys(product.discount).length > 0 &&
                    discountValue > 0 ? (
                    <ins>{formattedPrice}</ins>
                  ) : (
                    product.price && <ins> {roundedPrice}</ins>
                  )}
                  {Object.keys(product.discount).length > 0 &&
                    discountValue > 0 && (
                      <del className="m-product_price_old">{roundedPrice}</del>
                    )}
                </div>
              )}
              {product.rating && (
                <RatingContainer>
                  <Rcrating
                    defaultValue={(product.rating && product.rating.avg) || 0}
                    size={18}
                    colorActive={colors.mikadoYellowStar}
                    disabled
                  />
                  <RatingReviewCounting
                    onClick={() =>
                      redirectProductDetailFromRating(product.slug)
                    }
                  >
                    {(product.rating && product.rating.count) || 0} đánh giá
                  </RatingReviewCounting>
                </RatingContainer>
              )}
              <div
                className={joinClassnames(
                  "m-product_trademark",
                  trademarks &&
                  trademarks.length > 0 &&
                  "m-product_trademark-has-items",
                )}
              >
                {trademarks &&
                  trademarks.length > 0 &&
                  trademarks.map((tra: string) => (
                    <div className="m-product_trademark_item" key={tra}>
                      <Text modifiers={["white"]} size="sm">
                        {tra}
                      </Text>
                    </div>
                  ))}
              </div>

              {product.gift_value && (
                <div
                  className="m-product_promotion"
                  style={
                    product.gift_value
                      ? {
                        visibility: "visible",
                      }
                      : {
                        visibility: "hidden",
                      }
                  }
                >
                  <Icon iconName="gift-blue" />
                  <span
                    className="promotion_label"
                    data-text-mobile="Quà tặng"
                    data-text-desktop="Quà tặng trị giá"
                  />
                  <span className="promotion_price">
                    &nbsp;{window.formatMoney(product.gift_value)}
                  </span>
                </div>
              )}

              <div
                className={joinClassnames(
                  "m-product_trademark m-product_trademark-has-items",
                  tags && tags.length > 0 && "",
                )}
              >
                {tags}
              </div>
            </div>
          </div>

          {addToCardButton && (
            <div className="m-product_addtocard">
              {
                // OUTSTOCK BUTTON
              }
              {onProcessLocation ? (
                <WrapLoading>
                  <Loading widthHeight={COMMON_LOADING_SIZE} />
                </WrapLoading>
              ) : isBuyItem ? (
                outOfStock === 1 || outOfStock === 2 ? (
                  <BuyNowButton isItemProduct type="outstock" />
                ) : outOfStock === 0 ? (
                  <BuyNowButton
                    isItemProduct
                    type="buynow"
                    handleClick={(e: any) => {
                      addToCard(e, product);
                      onBuyingNow && onBuyingNow();
                    }}
                    {...(product.reserve
                      ? {
                        ctaText: product.reserve_text,
                        ctaDesc: product.reserve_short_description,
                      }
                      : {})}
                  />
                ) : (
                  <BuyNowButton isItemProduct type="outstock" />
                )
              ) : (
                <Button
                  variant="primary"
                  modifiers={["rounded"]}
                  onClick={e => addToCard(e, product)}
                >
                  tư vấn
                </Button>
              )}
            </div>
          )}

          {product.is_hot ? (
            <div className="m-product_tag">
              <Tag modifiers={["hot"]} color={product.hot_color || lava}>{product.hot_text || "Hot"}</Tag>
              {Object.keys(product.discount).length > 0 &&
                discountValue.split(".")[0] > 0 && (
                  <Tag modifiers={["sale", "radius-all"]}>
                    {`GIẢM ${formattedPricePromotion}%`}
                  </Tag>
                )}
            </div>
          ) : (
            product.discount && Object.keys(product.discount).length > 0 &&
            discountValue > 0 && (
              <div className="m-product_tag">
                <Tag modifiers={["sale"]}>{`GIẢM ${formattedPricePromotion}%`}</Tag>
              </div>
            )
          )}

          {productTypeIdValue && ( //con sky-air
            <div className="m-product_compare">
              {compareSelected ? (
                <Button
                  role="button"
                  aria-label="Compare Button"
                  aria-roledescription="compare button"
                  variant={"dark"}
                  modifiers={["xsmall", "rounded"]}
                  onClick={(e: any) => handleUnCompare(e, product)}
                  className="compare-button selected"
                  dataAttr="So sánh"
                />
              ) : (
                <Button
                  role="button"
                  aria-label="Compare Button"
                  aria-roledescription="compare button"
                  element="secondary"
                  modifiers={["xsmall", "rounded", "black"]}
                  onClick={(e: any) => handleCompare(e, product)}
                  className="compare-button"
                  dataAttr="So sánh"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {loadingToAddToCart && <LoadingState mask />}
    </>
  ) : (
    <></>
  );
};

Product.defaultProps = {
  element: "home",
  addToCardButton: true,
  compareButton: true,
};

export default React.memo(Product);
